import { createFileRoute, Outlet } from '@tanstack/react-router';
import { assertUuidRouteParams } from '../../../lib/assert-uuid-route-params.js';

export const Route = createFileRoute('/warehouses/$locationGroupId')({
  beforeLoad: ({ params }) => assertUuidRouteParams(params),
  component: () => <Outlet />,
});
